import { Observable, throwError } from 'rxjs';
import { Inject, Injectable, Injector, SkipSelf } from '@angular/core';
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { ContinueJourneyResponse, DiscoveryChatQuestion } from './model/discovery-chat.interface';
import { APIS } from '../apis';
import { AbstractDiscoveryProcessService } from './discovery-process.abstract.service';
// import { tEnvironment } from '../moov-common/tokens/environment.token';
// import { IEnvironment } from 'src/environments/environment.interface';

@Injectable({
  providedIn: 'root'
})
export class DiscoveryProcessService implements AbstractDiscoveryProcessService {
  startUserJourneyUrl = `${APIS.discoveryProcess}/startUserJourney`;
  continueUserJourneyUrl = `${APIS.discoveryProcess}/continueUserJourney`;
  getNextBatchUrl = `${APIS.discoveryProcess}/journeyGetNextBatch`;
  journeyGetQuestionsInBatchUrl = `${APIS.discoveryProcess}/journeyGetQuestionsInBatch`;
  journeySetQuestionResponseUrl = `${APIS.discoveryProcess}/journeySetQuestionResponse`;
  rediscoverGetQuestionsForMotivationUrl = `${APIS.discoveryProcess}/rediscoverGetQuestionsForMotivation`;
  rediscoverGetTailQuestionUrl = `${APIS.discoveryProcess}/rediscoverGetTailQuestion`;
  rediscoverGetMotivationGapQuestionUrl = `${APIS.discoveryProcess}/rediscoverGetMotivationGapQuestion`;
  rediscoverUpdateUserMotviationUrl = `${APIS.discoveryProcess}/rediscoverUpdateUserMotviation`;
   constructor(private http: HttpClient){}
  // constructor(@SkipSelf() private http: HttpClient){}
  // constructor(@SkipSelf() private injector: Injector) {
    
  // }
  
  // get http() {
  //   return this.injector.get(HttpClient);
  // }

  
  startUserJourney() : Observable<string> {
    // console.log('starting journey for user ' + userId);
    const url = `${this.startUserJourneyUrl}`;
    // console.log(`calling ${url}`);
    let response = this.http.get<string>(url);
    return response;
  }

   
  continueUserJourney() : Observable<ContinueJourneyResponse> {
    const url = `${this.continueUserJourneyUrl}`;
    return this.http.get<ContinueJourneyResponse>(url);
  }

  getNextBatch(userId: string): Observable<DiscoveryChatQuestion[]> {
    const url = `${this.getNextBatchUrl}?userId=${userId}`;
    // console.log(`calling ${url}`);
     let response = this.http.get<DiscoveryChatQuestion[]>(url);
     return response;
  }

  journeyGetQuestionsInBatch(): Observable<DiscoveryChatQuestion[]> {
    const url = `${this.journeyGetQuestionsInBatchUrl}`;
    // console.log(`calling ${url}`);
     let response = this.http.get<DiscoveryChatQuestion[]>(url);
     return response;
  }

  journeySetQuestionResponse(questionId: string, responseIds:string[]): Observable<string> {
    const url = `${this.journeySetQuestionResponseUrl}?questionId=${questionId}&responseId=${responseIds.join()}`;
    // console.log(`calling ${url}`);
    let response = this.http.get<string>(url);
    return response;
  }

  rediscoverGetQuestionsForMotivation(motivationInDispute: string): Observable<DiscoveryChatQuestion[]>{
    const url = `${this.rediscoverGetQuestionsForMotivationUrl}?motivationInDispute=${motivationInDispute}`;
    // console.log(`calling ${url}`);
     let response = this.http.get<DiscoveryChatQuestion[]>(url);
     return response;    
  }

  rediscoverGetTailQuestion(motivationInDispute: string): Observable<DiscoveryChatQuestion[]>{
    const url = `${this.rediscoverGetTailQuestionUrl}?motivationInDispute=${motivationInDispute}`;
    // console.log(`calling ${url}`);
     let response = this.http.get<DiscoveryChatQuestion[]>(url);
     return response;    
  }
  
  rediscoverGetMotivationGapQuestion(newMotivationId: string): Observable<DiscoveryChatQuestion[]>{
    const url = `${this.rediscoverGetMotivationGapQuestionUrl}?newMotivationId=${newMotivationId}`;
    // console.log(`calling ${url}`);
     let response = this.http.get<DiscoveryChatQuestion[]>(url);
     return response;    
  }
  
  rediscoverUpdateUserMotviation(motivationInDispute: string, newMotivationId: string, motivationGapScore: number): Observable<string>{
    const url = `${this.rediscoverUpdateUserMotviationUrl}`;
    // console.log(`calling ${url}`);
     let response = this.http.post<string>(url, {motivationInDispute:motivationInDispute, newMotivationId:newMotivationId, motivationGapScore: motivationGapScore});
     return response;    
  }  
}
